// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZGGM","type":"styles_type__1zVPo","choices":"styles_choices__1DlmF"};